module.exports = __webpack_public_path__ + "img/Loading-bar.d787105b.gif";